export default __webpack_public_path__ + "static/media/asideOnb.d31d34ca.png";